define([
	"dojo/store/Memory",
	"csi",
	"csi/locale"
], function(Memory, csi, locale) {

	/**
	 * Generate data store of reflection classes passing the given filter
	 * @param {ReflectionClass[]} classes
	 * @param {(rc: ReflectionClass) => boolean} [filterFunc]
	 * @param {(rc: ReflectionClass, item: {id: string, name: string}) => void} [itemFunc]
	 * @return {Memory}
	 */
	return function(classes, filterFunc, itemFunc) {
		const data = csi.transform(classes, (rc) => {
			if (rc.enabled && (!filterFunc || filterFunc(rc))) {
				const id = rc.type;
				const item = {id, name: locale.type(id)};
				itemFunc?.(rc, item);
				return item;
			}

			return null;
		});

		return new Memory({
			data: csi.sort(data || [], "name")
		});
	};
});